import { useT } from '../i18n/useT';
import { hero as heroEn } from '../i18n/translations/en';
import { hero as heroEs } from '../i18n/translations/es';
import './Hero.css';

const Hero = () => {
    const t = useT({ en: heroEn, es: heroEs });
    return (
        <section className="hero">
            <div className="hero-background">
                <video
                    className="hero-video"
                    src="/assets/videos/main.mp4"
                    autoPlay
                    loop
                    muted
                    playsInline
                />
                <div className="hero-pattern"></div>
            </div>
            <div className="container hero-content">
                <div className="hero-text">
                    <span className="hero-subtitle">{t.subtitle}</span>
                    <h1 className="hero-title">{t.title1}<span>{t.titleSpan}</span></h1>
                    <p className="hero-description">{t.description}</p>
                    <div className="hero-actions">
                        <a href="#space" className="btn btn-primary btn-large">{t.ctaPrimary}</a>
                        <a href="#why-venus" className="btn btn-secondary btn-large">{t.ctaSecondary}</a>
                    </div>
                </div>
                <div className="hero-stats-preview ED-panel">
                    <div className="stat-item">
                        <span className="stat-number">3.5<small>M</small></span>
                        <span className="stat-label">{t.stat1Label}</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-number">24<small>mi</small></span>
                        <span className="stat-label">{t.stat2Label}</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-number">Prime</span>
                        <span className="stat-label">{t.stat3Label}</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
